import React from "react";
import { getColor, getTextColor } from "../../common/ThemeService";
import { partyBrands } from '../../common/config.js';
const PreFlop = "/images/pokerwhiz/Early_2x.png";
const LatePosition = "/images/pokerwhiz/Late_2x.png";
const PokerWhizz_Drive = "/images/pokerwhiz/DriveNormal_Whizz.gif";
const PokerWhizz_Drive_generic = "/images/pokerwhiz/DriveNormal_Whizz_generic.gif";

const Blinds = "/images/pokerwhiz/Blinds_2x.png";
const PostFlop = "/images/pokerwhiz/Postflop_2x.png";

export const buttonsMap = {
    initial: {
        className: "button-div-initial",
        buttons: [
            {
                name: '',
                className: 'button-skip',
                onClickName: ''
            },
            {
            name: 'EXIT',
            className: 'button-skip',
            onClickName: 'skip'
        },
        {
            name: 'NEXT',
            className: 'button-next',
            onClickName: 'next',
        }]
    },
    middle: {
        className: "button-div-initial",
        buttons: [{
            name: 'PREV',
            className: 'button-skip button-prev',
            onClickName: 'prev',
        }, {
            name: 'EXIT',
            className: 'button-skip',
            onClickName: 'skip',
        }, {
            name: 'NEXT',
            className: 'button-next',
            onClickName: 'next',
        }]
    },
    end: {
        className: "button-end-mygame",
        buttons: [{
            name: 'LEARN MORE',
            className: '',
            onClickName: 'reset',
        }]
    }
}
export const imagesList = [{
    image: partyBrands.includes(localStorage.getItem("loggedInType"))? PokerWhizz_Drive:PokerWhizz_Drive_generic,
    imageClass : "intro-first-img",
    isBulletNeed:true,
    content: {
        title: 'Why Position Matters',
        description: "Always be aware of your position. The later you act, the more information you have to help you make a good decision."
    }
},
{
    image: PreFlop,
    imageClass:'intro-custom-img',
    isBulletNeed:true,
    content: {
        title:'Early Position',
        description: "The first 2 seats to the left of the blinds. Named Under the Gun (UTG) and UTG+1. These positions act first pre-flop."
    }
},
{
    image: LatePosition,
    isBulletNeed:true,
    content: {
        title: 'Late Position',
        description: "The 2 seats to the right of the blinds. Named Cutoff (CO) and Button. These positions act last pre-flop."
    }
},
{
    image: Blinds,
    isBulletNeed:true,
    content: {
        title: 'Blinds',
        description: "The 2 seats to the left of the button. Named Small Blind (SB) and Big Blind (BB). These players are forced to post a bet before cards are dealt."
    }
},
{
    image: PostFlop,
    isBulletNeed:true,
    content: {
        title: 'Post Flop',
        description: "If you are first to act post-flop, you are out of position. If you are last to act pre flop, you are in position. Acting last is a big advantage."
    }
},
{
    image: partyBrands.includes(localStorage.getItem("loggedInType"))? PokerWhizz_Drive:PokerWhizz_Drive_generic,
    imageClass : "intro-first-img",
    isBulletNeed:false,
    content: {
        title: 'Want to Learn More?',
        description: "To deep dive into all the table positions & their optimisation check out our course content."
    }
}]

export const ImageComponent = (props) => {
    // console.log('IntroComponent', props);
    const imageObj = imagesList[props.index - 1];
    let driveImageClass = false;
    if (props.index === 1 || props.index === imagesList.length) {
        driveImageClass= true;
    }
    return <div className="row common-row-style m-0">
        <div className="col-12 d-flex justify-content-center">
            <img
                className={(driveImageClass ? " general-img_driveImageClass" : "")}
                src={props.baseUrlImg + imageObj.image}
                role="presentation"
            />
        </div>
    </div>
}
export const ContentDiv = (props) => {
    let contentObj = imagesList[props.index - 1].content;
    return <div className="content-description-row row no-gutters w-100 pl-2 pr-2">
        <div className="content-header-style col-12">
            {contentObj.title}
        </div>
        <div className="content-description-style col-12">
            {contentObj.description}
        </div>
    </div>
}
export const Bullets = (props) => {
    const themeColor = getColor()
    return imagesList[props.count-1].isBulletNeed && <div className="learn-bullet-div">
        {imagesList.map((img, index) => {
            return img.isBulletNeed && <i key={index} className={"fa fa-circle " + (props.count === index + 1
                ? "bullet-background-style"
                : "bullet-disable-background-style")} style={ props.count === index + 1 ? {
                    color: themeColor,
                    fontSize: '10px',
                } : { fontSize: '10px' }}>&nbsp;&nbsp;&nbsp;&nbsp;</i>
        })}
    </div>
}
export const ButtonsNeeded = (props) => {
    const themeColor = getColor()
    const themeTextColor = getTextColor()
    let buttonObj = props.index === 1 ? buttonsMap['initial']
        : props.index === imagesList.length ?buttonsMap['end']:buttonsMap['middle'];
    return <div className={buttonObj.className} style={{paddingTop: (props.index === 1) ? '23px' : '0px'}}>
        <style>
            {`
                .button-next {\
                    color: ${themeColor};\
                }\
                .button-end-mygame {\
                    background-color: ${themeColor};\
                    color: ${themeTextColor};\
                }\
            `}
        </style>
        {buttonObj.buttons.map((item, index) => {
            if (item.name === "EXIT")
                return <Bullets key={index} count={props.index} />
            else if (item.name === "LEARN MORE") 
                return <span key={index} data-dismiss="modal" className={item.className + " cursor-pointer"} onClick={props[[item.onClickName]]} data-e2e={item.name}>{item.name}</span>
            else 
                return <span key={index} className={item.className + " cursor-pointer"} onClick={props[[item.onClickName]]}>{item.name}</span>
        })}
    </div>
}


/** WEBPACK FOOTER **
 ** ./src/components/LearnMore/LearnMoreComponent.js
 **/